<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/advert/lists"
    >
      <template v-slot:searchFormItem>
        <!--<FormItem prop="day">
          <DatePicker v-model="searchData.day" type="daterange" placement="bottom-start" placeholder="打款日期" style="width: 200px"></DatePicker>
        </FormItem>-->
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="showEditDrawer(0)">添加</Button>
        </FormItem>
      </template>

    </pageTable>

    <edit-form v-if="showEdit"
               :show-edit="showEdit"
               :id="editId"
               ref="editModel"
               @cancel-edit="closeEditDrawer"
               @edit-success="editSuccess"
    >
    </edit-form>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  import editForm from "./edit";
  export default {
    name: "lists",
    components:{pageTable,editForm},
    data() {
      return {
        showEdit:false,
        editId:0,
        searchData: {
          mobile: '',
          name:'',
          day:'',
          type:'',
        },
        tableColumn: [
          {title: 'ID',key: 'advert_id'},
          {title: '标题',key: 'advert_title'},
          {title: '图片',key: 'advert_img',render:(h,params)=>{
            return h('img',{
              attrs:{src:params.row.advert_img},
              style:{width:'80px',height:'80px'
              },
              on:{click:()=>{
                  this.$Modal.info({
                    // title: title,
                    width:800,
                    footerHide:true,
                    content: `<img src="${params.row.advert_img}" style="max-width: 500px;max-height: 500px">`
                  });
                }}
            })
            }},
          {title: '是否显示',key: 'advert_status',render:(h,params)=>{
            let status = parseInt(params.row.advert_status);
            if (status === 1){
              return h('span','显示')
            }else{
              return h('Tag',{props:{type:'error'}},'不显示')
            }
          }},
          {title: '操作',align:'center',render:(h,params)=>{
              let content=[];
              content.push(h('Button',{
                  props: {type: 'primary', size: 'small',},
                  style: {marginLeft: '5px'},
                  on: {click: () => {this.showEditDrawer(params.row.advert_id)}
                }
              },'编辑'))
              content.push(h('Button',{
                props: {type: 'error', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.del(params.row.advert_id)}
                }
              },'删除'))
              return h('div',content)
            }},
        ],
      }
    },
    methods: {
      showEditDrawer(id){
        this.showEdit = true;
        this.editId = id
      },
      closeEditDrawer(){
        this.showEdit = false
        this.editId = 0
      },
      editSuccess(){
        this.$refs.table.getLists();
        this.showEdit = false
      },
      async del(id){
        let res = await this.$commonFun.postProxy('admin/advert/del',{id})
        this.$commonFun.dealApiResult(res,()=>{
          this.$refs.table.getLists();
          this.$commonFun.successTip(res.msg)
        })
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
